import { render, staticRenderFns } from "./lifeExpertList.vue?vue&type=template&id=8490b924&scoped=true"
import script from "./lifeExpertList.vue?vue&type=script&lang=js"
export * from "./lifeExpertList.vue?vue&type=script&lang=js"
import style0 from "./lifeExpertList.vue?vue&type=style&index=0&id=8490b924&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8490b924",
  null
  
)

export default component.exports